<template>
  <div class="menu-details">
    <div class="menu-buttons">
      <nav class="menu-items">
        <router-link to="/" @click="checkIsSamePath('/')">
          <MobileNavButton icon="map">Карта</MobileNavButton>
        </router-link>
        <router-link
          to="/account/settings"
          @click="checkIsSamePath('/account/settings')"
        >
          <div class="profile-wrapper" v-if="avatar">
            <VImage :src="avatar" class="avatar-wrapper" />
            <span class="avatar-text">Профиль</span>
          </div>
          <MobileNavButton v-else icon="settings">Профиль</MobileNavButton>
        </router-link>
        <router-link
          to="/account/favorites"
          @click="checkIsSamePath('/account/favorites')"
        >
          <MobileNavButton icon="favorites">Избранное</MobileNavButton>
        </router-link>
        <router-link
          to="/account/bookings"
          @click="checkIsSamePath('/account/bookings')"
        >
          <MobileNavButton icon="bookings">Брони</MobileNavButton>
        </router-link>
        <router-link
          to="/account/reviews"
          @click="checkIsSamePath('/account/reviews')"
        >
          <MobileNavButton icon="reviews">Отзывы</MobileNavButton>
        </router-link>
      </nav>
      <SupportLink class="menu-button" :roleGroup="'client'" />
    </div>
    <div class="details">
      <div class="journal">
        <a href="https://vkusno.namtam.ru" target="_blank" class="journal-icon">
          <IconBook />
        </a>
        <div class="journal-item">
          <a
            href="https://vkusno.namtam.ru"
            target="_blank"
            class="journal-title"
          >
            Намтам Вкусно
          </a>
          <a
            href="https://vkusno.namtam.ru"
            target="_blank"
            class="journal-subtitle"
          >
            Журнал о еде и ресторанах
          </a>
        </div>
      </div>
      <div class="links">
        <a href="https://vkusno.namtam.ru/we-are-namtam" target="_blank">
          О нас
        </a>
        <a href="https://vkusno.namtam.ru/docs/confident" target="_blank">
          Политика конфиденциальности
        </a>
        <a href="https://vkusno.namtam.ru/docs/lagreement" target="_blank">
          Лицензионное соглашение
        </a>
        <a href="https://b2b.namtam.ru" target="_blank">Для ресторанов</a>
        <a href="https://vkusno.namtam.ru/docs/oferta" target="_blank">
          Оферта
        </a>
        <a href="https://vkusno.namtam.ru/faq" target="_blank">FAQ</a>
      </div>
      <div class="social-links">
        <div class="social-links-item">
          <a
            href="https://t.me/namtam_ekb"
            target="_blank"
            class="social-links-icon"
          >
            <IconTG />
          </a>
          <a
            href="https://t.me/namtam_ekb"
            target="_blank"
            class="social-links-title"
          >
            Telegram
          </a>
        </div>
        <div class="social-links-item">
          <a
            href="https://vk.com/club228183420?utm_source=b2c&utm_medium=web&utm_campaign=podval"
            target="_blank"
            class="social-links-icon"
          >
            <IconVK />
          </a>
          <a
            href="https://vk.com/club228183420?utm_source=b2c&utm_medium=web&utm_campaign=podval"
            target="_blank"
            class="social-links-title"
          >
            Вконтакте
          </a>
        </div>
      </div>
      <div class="contact">
        <a
          href="https://jivo.chat/2EfX44qOaO"
          target="_blank"
          class="contact-text"
        >
          Поддержка
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SupportLink from "@/components/SupportLink.vue";
import IconBook from "@/components/icons/IconBook.vue";
import IconTG from "@/components/icons/IconTG.vue";
import IconVK from "@/components/icons/IconVK.vue";
import MobileNavButton from "@/components/ui/MobileNavButton.vue";
import VImage from "@/components/ui/VImage.vue";

export default {
  name: "MenuMobile",
  components: {
    VImage,
    MobileNavButton,
    IconVK,
    IconTG,
    IconBook,
    SupportLink,
  },
  methods: {
    checkIsSamePath(path) {
      if (path === this.path) {
        this.$store.commit("toggleMenu");
      }
    },
  },
  computed: {
    avatar() {
      return this.$store.state.general.userInfo?.avatar;
    },
    path() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.menu-details {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  z-index: 2147483645;
  padding: 0 16px 32px;

  .menu-buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  .menu-button {
    width: 100%;
    height: 48px;
  }
}

.journal {
  display: flex;
  align-items: center;
  gap: 16px;

  .journal-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 16px;
    background-color: #fef6e8;
  }
  .journal-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .journal-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  }
  .journal-subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #858585;
  }
}

.details {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 16px;
  border-top: 1px solid #d6d6d6;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 12px;

  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
}

.social-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding-top: 8px;
}
.social-links-item {
  display: flex;
  align-items: center;
  gap: 12px;
}
.social-links-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #222222;
}
.social-links-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.contact {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  width: 100%;

  .contact-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #858585;
  }
}

.menu-items {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #222222;
}

.avatar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 16px;
}

.avatar-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
</style>
